import { css } from '@agapi/ui/panda/css';
import { sva } from '@agapi/ui/panda/css';

export const collectionHeaderStyles = sva({
  slots: ['root', 'contentWrapper', 'content', 'imageWrapper', 'image', 'title', 'description', 'expandButton', 'childCollectionButton'],
  base: {
    root: {
      paddingTop: { base: '6', md: '5' }
    },
    contentWrapper: {
      display: 'flex',
      flexDirection: { base: 'column-reverse', md: 'row' },
      gap: { base: 'snug', md: 'normal' },
      alignItems: 'flex-start'
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      gap: 'tight'
    },
    expandButton: {
      backgroundColor: 'surface.primary.tonal.background',
      color: 'surface.primary.tonal.foreground',
      _hover: {
        backgroundColor: 'primary.100',
        boxShadow: '1px 2px 8px -3px rgba(0, 0, 0, 0.18)'
      }
    },
    imageWrapper: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      alignItems: { base: 'stretch', md: 'flex-end' },
      width: {
         base: '100%',
         md: 'unset'
      }
    },
    image: {
      rounded: 'surface.sm',
      mdDown: {
        minWidth: '100%',
      },
    },
    title: {
      pb: '5'
    },
    description: {
      display: 'flex',
      flexDirection: 'column',
      gap: '3',
      '& h2': {
        textStyle: 'h4'
      },
      '& p': {
        pb: '3'
      }
    }
  }
});

